export function getTestState({ PCLN_BOOTSTRAP_DATA, setiName }) {
  return PCLN_BOOTSTRAP_DATA?.SETI[setiName]?.variantName || 'DEFAULT'
}

export function getListingsTestState({ PCLN_BOOTSTRAP_DATA, setiName }) {
  const setiInfo = PCLN_BOOTSTRAP_DATA?.requestLocals?.seti.find((s) => {
    return s.setiTagName === setiName
  })
  return setiInfo?.setiVariantName || 'DEFAULT'
}
